import { Button, Form, Input, InputNumber, message } from 'antd';
import React, { useState } from 'react'
import { useGwGoodsTypeAddMutation } from '../../store/ReactWebSiteApi';
import { Modal } from 'antd';

function WebGoodsTypeAdd() {
    const [form] = Form.useForm();
    const [info,setInfo] = useState({
        eowgt_content:'',
    });
    const [submitAdd] = useGwGoodsTypeAddMutation()
    const [open, setOpen] = useState(false);
    return (
        <>
            <Button type='primary' onClick={() => {setOpen(true)}}>新增</Button>
            <Modal
                open={open}
                title='新增系统类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    submitAdd({
                        eowgt_name:info.eowgt_name,
                        eowgt_e_id:localStorage.getItem('e_id'),
                        eowgt_uid:localStorage.getItem('eu_id'),
                        eowgt_uname:localStorage.getItem('eu_name'),
                        eowgt_serial_number:info.eowgt_serial_number,
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('新增成功！')  
                            form.resetFields();      
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                    setOpen(false);
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 5}}                    
                >   
                    <Form.Item name="name" label='系统类型' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,eowgt_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="serial" label='序号' wrapperCol={{span:10}} required>
                        <InputNumber  onChange={(e) => {setInfo(prevState=>({...prevState,eowgt_serial_number:e}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default WebGoodsTypeAdd